"use strict";

var Share = require("./share.min.js");

new Share(".share", {
  ui: {
    flyout: "bottom left"
  },
  networks: {
    email: {
      description: window.location.href
    }
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9ld2ViZWNrL0RvY3VtZW50cy9HaXRIdWIvbWFyaW5lcnMtbGluZXVwLTIwMTgvc3JjL2pzL2xpYi9zb2NpYWwuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFJLEtBQUssR0FBRyxPQUFPLENBQUMsZ0JBQWdCLENBQUMsQ0FBQzs7QUFFdEMsSUFBSSxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ2xCLElBQUUsRUFBRTtBQUNGLFVBQU0sRUFBRSxhQUFhO0dBQ3RCO0FBQ0QsVUFBUSxFQUFFO0FBQ1IsU0FBSyxFQUFFO0FBQ0wsaUJBQVcsRUFBRSxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUk7S0FDbEM7R0FDRjtDQUNGLENBQUMsQ0FBQyIsImZpbGUiOiIvVXNlcnMvZXdlYmVjay9Eb2N1bWVudHMvR2l0SHViL21hcmluZXJzLWxpbmV1cC0yMDE4L3NyYy9qcy9saWIvc29jaWFsLmpzIiwic291cmNlc0NvbnRlbnQiOlsidmFyIFNoYXJlID0gcmVxdWlyZShcIi4vc2hhcmUubWluLmpzXCIpO1xuXG5uZXcgU2hhcmUoXCIuc2hhcmVcIiwge1xuICB1aToge1xuICAgIGZseW91dDogXCJib3R0b20gbGVmdFwiXG4gIH0sXG4gIG5ldHdvcmtzOiB7XG4gICAgZW1haWw6IHtcbiAgICAgIGRlc2NyaXB0aW9uOiB3aW5kb3cubG9jYXRpb24uaHJlZlxuICAgIH1cbiAgfVxufSk7XG4iXX0=